
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { SurfaceDevelopmentScheduleActivityDto, SurfaceDevelopmentScheduleResetResponse, SurfaceDevelopmentScheduleSaveResponse } from './app-schedule-task-surfacedev.dtos';

@Injectable()
export class surfacedevService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  public async saveChangedRows(projectId: number, scheduleId: number, changedRowsToSave: SurfaceDevelopmentScheduleActivityDto[]): Promise<SurfaceDevelopmentScheduleSaveResponse> {
    const url = `${this.BASE_URL}estimatetaskmapping/surfacedevelopment/saveSurfaceDevScheduleChanges`;

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http
      .put<SurfaceDevelopmentScheduleSaveResponse>(url, { ProjectId: projectId, ScheduleId: scheduleId, ActivitiesToSave: changedRowsToSave }, { headers: headers })
      .toPromise();
  }

  public async resetToDrillSchedule(projectId: number, phasesToSync: string[], hasActualDates: boolean): Promise<SurfaceDevelopmentScheduleResetResponse> {
    //This will default all default planned durations and syncs to drill schedule.
    const url = `${this.BASE_URL}estimatetaskmapping/surfacedevelopment/resetScheduleToDrillSchedule`;
    const body = {
      ProjectId: projectId,
      Phases: phasesToSync,
      HasActualDates: hasActualDates
    };

    let result = await this.http.post<SurfaceDevelopmentScheduleResetResponse>(url, body, { headers: this.headers }).toPromise();
    if (result.ScheduleActivities) {
      result.ScheduleActivities = result.ScheduleActivities.map(item => new SurfaceDevelopmentScheduleActivityDto(item));
    }
    return result;
  }
}